class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.fetch_delay = 0;
  }

  connectedCallback() {
   
    this._showSkeleton();

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(this);

          this.fetch_delay = Number(
            window.theme?.complementary_products_fetch_delay || '0',
          );

          setTimeout(() => {
            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector(
                  'product-recommendations',
                );

                if (
                  recommendations &&
                  recommendations.innerHTML.trim().length
                ) {
                  const existingContentCards =
                    this.querySelectorAll('.product-card');
                  const newContentCards = Array.from(
                    recommendations.querySelectorAll('.product-card'),
                  );

                  if (
                    newContentCards.length > 0 &&
                    newContentCards.length > 0 &&
                    existingContentCards.length === newContentCards.length
                  ) {
                    existingContentCards.forEach((card, i) =>
                      card.replaceWith(newContentCards[i]),
                    );
                  } else {
                    this.innerHTML = recommendations.innerHTML;
                  }

                  let ajaxCartLoadInterval = setInterval(() => {
                    if (window.theme.ajaxCartInitiated) {
                      const forms = this.querySelectorAll('.js-product-form');

                      Array.from(forms).forEach((form) =>
                        window.ajaxCart.initForm(form),
                      );

                      clearInterval(ajaxCartLoadInterval);
                    }
                  }, 50);

                  if (this.dataset.quickShopDynamicCheckout === 'true') {
                    let shopifyPaymentButtonInterval = setInterval(() => {
                      if (window.Shopify.PaymentButton) {
                        window.Shopify.PaymentButton.init();

                        clearInterval(shopifyPaymentButtonInterval);
                      }
                    }, 50);
                  }

                  if (
                    document.body.dataset.animLoad === 'true' &&
                    typeof window.sr !== 'undefined' &&
                    !this.hasAttribute('animated')
                  ) {
                    const cardsToAnimate =
                      this.querySelectorAll('.product-card-top');

                    cardsToAnimate.forEach((el) => {
                      const container = el.closest('.grid-layout');

                      window.sr.reveal(el, {
                        container,
                        interval: 50,
                      });
                    });
                  }
                } else {
                 
                  this.innerHTML = '';
                }
              })
              .catch((e) => {
                this.innerHTML = '';
                console.error(e);
              });
          }, this.fetch_delay);
        }
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }


  _showSkeleton() {
   
    if (this.querySelector('.product-card')) return;

    ProductRecommendations._injectGlobalStyles();

    
    const cols = this._detectCols();

   
    if (this.querySelector('.pr-skeleton__card')) return;

    const cards = Array.from({ length: cols }, () =>
      this._buildSkeletonCard(),
    ).join('');

    this.innerHTML = `
      <div class="pr-skeleton pr-skeleton--cols-${cols}">
        ${cards}
      </div>
    `;
  }

  _detectCols() {
 
    if (this.dataset.skeletonCols) {
      return parseInt(this.dataset.skeletonCols, 10);
    }

 
    const url = this.dataset.url || '';
    const limitMatch = url.match(/[?&]limit=(\d+)/);
    if (limitMatch) {
      const limit = parseInt(limitMatch[1], 10);
      
      return Math.min(limit, 3);
    }

    return 3; 
  }

  _buildSkeletonCard() {
  
    const ratio = parseInt(this.dataset.skeletonRatio || '120', 10);

    return `
      <div class="pr-skeleton__card">
        <div class="pr-skeleton__image pr-skeleton__shimmer" style="padding-bottom:${ratio}%"></div>
        <div class="pr-skeleton__body">
          <div class="pr-skeleton__line pr-skeleton__shimmer" style="width:42%;height:11px;margin-bottom:6px"></div>
          <div class="pr-skeleton__line pr-skeleton__shimmer" style="width:88%;height:14px;margin-bottom:5px"></div>
          <div class="pr-skeleton__line pr-skeleton__shimmer" style="width:62%;height:14px;margin-bottom:6px"></div>
          <div class="pr-skeleton__line pr-skeleton__shimmer" style="width:55%;height:11px;margin-bottom:8px"></div>
          <div class="pr-skeleton__line pr-skeleton__shimmer" style="width:36%;height:14px;margin-bottom:10px"></div>
          <div class="pr-skeleton__swatches">
            <div class="pr-skeleton__swatch pr-skeleton__shimmer"></div>
            <div class="pr-skeleton__swatch pr-skeleton__shimmer"></div>
          </div>
        </div>
      </div>
    `;
  }

 
  static _stylesInjected = false;

  static _injectGlobalStyles() {
    if (ProductRecommendations._stylesInjected) return;
    ProductRecommendations._stylesInjected = true;

    const style = document.createElement('style');
    style.textContent = `
     
      @keyframes pr-shimmer {
        0%   { background-position: -600px 0; }
        100% { background-position:  600px 0; }
      }

      .pr-skeleton__shimmer {
        background: linear-gradient(
          90deg,
          var(--color--border, #e5e5e5) 25%,
          var(--color--bg-alt, #f2f2f2) 50%,
          var(--color--border, #e5e5e5) 75%
        );
        background-size: 600px 100%;
        animation: pr-shimmer 1.4s infinite linear;
      }

     
      .pr-skeleton {
        display: flex;
        gap: 12px;
        width: 100%;
      }

      .pr-skeleton__card {
        flex: 1 1 0;
        min-width: 0;
      }

     
      @media (max-width: 767px) {
        .pr-skeleton__card {
          flex: 0 0 100%;
        }
        .pr-skeleton__card:not(:first-child) {
          display: none;
        }
      }

     
      .pr-skeleton__image {
        width: 100%;
        border-radius: 4px;
        margin-bottom: 10px;
      }

     
      .pr-skeleton__body { padding: 0 2px; }

      .pr-skeleton__line {
        border-radius: 3px;
        display: block;
      }

    
      .pr-skeleton__swatches {
        display: flex;
        gap: 6px;
      }

      .pr-skeleton__swatch {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        flex-shrink: 0;
      }
    `;
    document.head.appendChild(style);
  }
}

customElements.define('product-recommendations', ProductRecommendations);